import { type ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface PageLayoutProps {
  header: ReactNode
  footer?: ReactNode
  children: ReactNode
  /** Pins the header to the top of the viewport while page scrolls. */
  stickyHeader?: boolean
}

export function PageLayout({ header, footer, children, stickyHeader = false }: PageLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <div className={cn(stickyHeader && 'sticky top-0 z-50')}>
        {header}
      </div>
      <main className="flex-1">{children}</main>
      {footer}
    </div>
  )
}
